import type { ViewHook } from '../helpers/utils'

type WriteEvent = { text: string }
type ReadRequestEvent = Record<string, unknown>

interface ClipboardHook extends ViewHook {
  mounted(): void
}

export const FacadeClipboard: Partial<ClipboardHook> = {
  mounted() {
    this.handleEvent('clipboard:write', async ({ text }: WriteEvent) => {
      try {
        await navigator.clipboard.writeText(text)
      } catch (_err) {
        this.pushEvent('clipboard_write_failed', {})
      }
    })

    this.handleEvent(
      'clipboard:read_request',
      async (params: ReadRequestEvent) => {
        try {
          const text = await navigator.clipboard.readText()
          this.pushEvent('clipboard_paste', { ...params, text })
        } catch (_err) {
          // Empty text — server treats "" as permission denied.
          this.pushEvent('clipboard_paste', { ...params, text: '' })
        }
      }
    )
  }
}
